import { labelFor } from "@/lib/labels";
import AutoForm from "./AutoForm";

export default function ObjectField({ fieldKey, value, onChange }) {
  return (
    <div className="rounded-xl border border-stone-200 p-4">
      <div className="text-sm font-semibold text-stone-700 mb-3">{labelFor(fieldKey)}</div>
      <AutoForm value={value} onChange={onChange} />
    </div>
  );
}
